var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.workspaceID)?_c('div',{staticStyle:{"padding":"20px"}},[_c('list',{attrs:{"workspaceID":_vm.workspaceID}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }